import axios from 'axios';
import serviceUtil from './serviceUtil';

let helpers = {
  getNotifications: () => {
    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/notifications?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.notifications
          ? response.data.notifications
          : response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getAllNotifications: () => {
    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/notifications/all?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.notifications
          ? response.data.notifications
          : response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  markRead: notification => {
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/notifications/' +
        notification.id +
        '/mark_read?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.notification;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  markAllActedOn: () => {
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/notifications/' +
        '/mark_all_acted_on?current_company=' +
        localStorage.current_company_id,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  markAllRead: () => {
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/notifications/mark_all_read?current_company=' +
        localStorage.current_company_id,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data.notifications;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  bannerDisplayed: notification => {
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/notifications/' +
        notification.id +
        '/mark_banner_displayed?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.notification;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  actedOn: notification => {
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/notifications/' +
        notification.id +
        '/mark_acted_on?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.notification;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;
  



// WEBPACK FOOTER //
// ./src/services/notificationsService.js